module.exports = __webpack_public_path__ + "static/media/logo-bicc-background.6bc8a3d5.png";